import { useAllocation } from '../useAllocation';
import { frontDoorOfferExp, variantExp } from '../../experiments/frontDoorOffer';
export { variantExp } from '../../experiments/frontDoorOffer';
export type AcquisitionOffer = {
  cell: 'fixed';
  discount: {
    kind: 'fixed';
    amountCents: number;
  };
  stylingFeeWaived: true;
} | {
  cell: 'percentage';
  discount: {
    kind: 'percentage';
    percentage: number;
  };
  stylingFeeWaived: true;
} | {
  cell: 'no-promo';
  discount: null;
  stylingFeeWaived: true;
};
export const mapAllocationToOffer = (value: string | undefined): AcquisitionOffer => {
  switch (value) {
    case 'percentage':
      return {
        cell: 'percentage',
        discount: {
          kind: 'percentage',
          percentage: 20
        },
        stylingFeeWaived: true
      };
    case 'no_promo':
      return {
        cell: 'no-promo',
        discount: null,
        stylingFeeWaived: true
      };
    case 'standard':
    default:
      return {
        cell: 'fixed',
        discount: {
          kind: 'fixed',
          amountCents: 2000
        },
        stylingFeeWaived: true
      };
  }
};
export const useFrontDoorOffer = (skip = false) => {
  const {
    data: allocationData,
    loading
  } = useAllocation(skip ? [] : [frontDoorOfferExp, variantExp]);
  const allocationValue = allocationData?.visitor?.configParams?.find(p => p.name === frontDoorOfferExp.name)?.value;
  const offer = loading ? null : mapAllocationToOffer(allocationValue);
  const slimBannerVariant = allocationData?.visitor?.configParams?.find(p => p.name === variantExp.name)?.value || variantExp.fallbackValue;
  return {
    offer,
    slimBannerVariant,
    loading
  };
};